import { fromJS } from "immutable";

export default {
	pageName: "adminSettingsNotifications",
	asapAndDeferredOptions: [
		{ label: "As Soon As Possible", name: "asap" },
		{ label: "Deferred", name: "deferred" },
		{ label: "Off", name: null },
	],
	digestOptions: [
		{ label: "On", name: "digest" },
		{ label: "Off", name: null },
	],
	adminDigestOptions: [
		{ label: "On", name: "adminDigest" },
		{ label: "Off", name: null },
	],
	dailyNotificationsOptions: fromJS([
		{ id: "once", label: "Once a day" },
		{ id: "twice", label: "Twice a day" },
	]),
	timeOptions: fromJS([
		{ id: "1", label: "1:00" },
		{ id: "2", label: "2:00" },
		{ id: "3", label: "3:00" },
		{ id: "4", label: "4:00" },
		{ id: "5", label: "5:00" },
		{ id: "6", label: "6:00" },
		{ id: "7", label: "7:00" },
		{ id: "8", label: "8:00" },
		{ id: "9", label: "9:00" },
		{ id: "10", label: "10:00" },
		{ id: "11", label: "11:00" },
		{ id: "12", label: "12:00" },
	]),
	meridiemOptions: fromJS([
		{ id: "am", label: "AM" },
		{ id: "pm", label: "PM" },
	]),
	dayOfTheWeekOptions: fromJS([
		{ id: "sunday", label: "Sunday" },
		{ id: "monday", label: "Monday" },
		{ id: "tuesday", label: "Tuesday" },
		{ id: "wednesday", label: "Wednesday" },
		{ id: "thursday", label: "Thursday" },
		{ id: "friday", label: "Friday" },
		{ id: "saturday", label: "Saturday" },
	]),
};
